import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "⏱️", key: "underTenMinutes" },
  { emoji: "🕒", key: "tenToThirty" },
  { emoji: "⌚", key: "thirtyToSixty" },
  { emoji: "🫠", key: "moreThanHour" },
]

export default function CarsTimeSpentPage() {
  return <RadioCardListPage translationKey="carsTimeSpent" options={OPTIONS} />
}
